import {
  DataKeys,
  DrilldownDataKeys,
} from "../../helpers/reports.helper.types";

export enum DrilldownRoutePage {
  Webfilter = "webfilter",
  Malware = "malware",
  Botnet = "botnet",
}

export interface ChartConfig {
  tableDataEndpoint: DrilldownDataKeys;
  chartDataEndpoint: DataKeys;
}
